<div class="loading-screen-container">
    <div class="loading-screen-content">
        <div class="spinner-border"></div>
        <p *ngIf="descriptionKey1">{{ descriptionKey1 | translate }}</p>
        <p *ngIf="descriptionKey2">{{ descriptionKey2 | translate }}</p>
    </div>
</div>
